import { Grid } from '@material-ui/core';
import { Form, FormikProps } from 'formik';
// @material-ui/icons
// core components
import GridContainer from '@components/Grid/GridContainer.js';
import GridItem from '@components/Grid/GridItem.js';
import Button from '@components/CustomButtons/Button';
import React from 'react';
import GoBackHeader from '@components/GoBackHeader/GoBackHeader';
import { itemFields } from '../constants';

import { IProductCategory } from '../types';
import OVSForm from '@components/Form/OVSForm';

const LegacyForm: React.FC<{
  formBag: FormikProps<IProductCategory>;
  disableLoginButton: boolean;
  actionButtonName?: string;
}> = (props) => {
  const { formBag, disableLoginButton, actionButtonName = 'Add Items' } = props;

  const formFieldsData = React.useMemo(
    () => [
      {
        name: '',
        fields: [
          {
            type: 'text',
            name: itemFields.productCategoryName,
            label: 'Category Name',
          },
          {
            type: 'textarea',
            name: itemFields.productCategoryDescription,
            label: 'Description',
          },
          {
            type: 'text',
            name: itemFields.image,
            label: 'Image URL',
          },
        ],
      },
    ], // eslint-disable-next-line
    [formBag.values]
  );

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <GoBackHeader title={actionButtonName} />
        <Form>
          <GridContainer>
            <GridItem xs={12}>
              <GridContainer>
                <OVSForm formFieldsData={formFieldsData} />
              </GridContainer>
            </GridItem>
          </GridContainer>

          <Grid>
            <Button
              color='primary'
              onClick={() => {
                formBag.submitForm();
                formBag.validateForm();
              }}
              disabled={disableLoginButton}
            >
              Save
            </Button>
          </Grid>
        </Form>
      </GridItem>
    </GridContainer>
  );
};

export default LegacyForm;
